import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import * as manualGuideService from "../../services/manual-guide.service";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { useTranslation } from "react-i18next";

const ManualGuideEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [detailsData, setDetailsData] = useState({});
  const [saveType, setSaveType] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: "Manual Guide",
      url: "/admin/manual-guide/list/1",
    },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    manualGuideService.Details(params.id)
      .then((response) => {
        setDetailsData(response && response.data ? response?.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);


  const validationSchema = Yup.object().shape({
    title: Yup.string().trim().required("This field is required"),
    title_ja: Yup.string().trim().required("This field is required"),
    breadcrumb_title: Yup.string().trim().required("This field is required"),
    breadcrumb_title_ja: Yup.string().trim().required("This field is required"),
    slug: Yup.string().trim().required("This field is required"),
    description: Yup.string().trim().required("This field is required"),
    description_ja: Yup.string().trim().required("This field is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title:detailsData && detailsData.title ? detailsData.title : "",
      title_ja:detailsData && detailsData.title_ja ? detailsData.title_ja : "",
      breadcrumb_title:detailsData && detailsData.breadcrumb_title ? detailsData.breadcrumb_title : "",
      breadcrumb_title_ja:detailsData && detailsData.breadcrumb_title_ja ? detailsData.breadcrumb_title_ja : "",
      slug:detailsData && detailsData.slug ? detailsData.slug : "",
      description:detailsData && detailsData.description ? detailsData.description : "",
      description_ja:detailsData && detailsData.description_ja ? detailsData.description_ja : "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      manualGuideService.Edit({o_id: params.id, ...values})
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            if (saveType !== "Save") {
              navigate(`/admin/manual-guide/list/1`);
            }
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          globalLoader(false);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(error),
            ...SWAL_SETTINGS,
          });
          console.log("error ====> ", error);
        });
    },
  });
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                  Edit Manual Guide 
                  </h6>
                </div>
                <div className="row row-sm">
                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="title" className="text-left d-flex">{"Title"}:<span className="requirestar">*</span>{" "}</label>
                    <input name="title" id="title" type="text" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.title} className="form-control" placeholder={"Please enter title"} />
                    <span className="text-danger d-flex text-left"><CustomError name="title" form={formik} /></span>
                  </div>
                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="title_ja" className="text-left d-flex">{"Title Japanese"}:<span className="requirestar">*</span>{" "}</label>
                    <input name="title_ja" id="title_ja" type="text" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.title_ja} className="form-control" placeholder={"Please enter title japanese"} />
                    <span className="text-danger d-flex text-left"><CustomError name="title_ja" form={formik} /></span>
                  </div>
                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="breadcrumb_title" className="text-left d-flex">{"Breadcrumb Title"}:<span className="requirestar">*</span>{" "}</label>
                    <input name="breadcrumb_title" id="breadcrumb_title" type="text" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.breadcrumb_title} className="form-control" placeholder={"Please enter breadcrumb title"} />
                    <span className="text-danger d-flex text-left"><CustomError name="breadcrumb_title" form={formik} /></span>
                  </div>
                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="breadcrumb_title_ja" className="text-left d-flex">{"Breadcrumb Title Japanese"}:<span className="requirestar">*</span>{" "}</label>
                    <input name="breadcrumb_title_ja" id="breadcrumb_title_ja" type="text" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.breadcrumb_title_ja} className="form-control" placeholder={"Please enter breadcrumb title Japanese"} />
                    <span className="text-danger d-flex text-left"><CustomError name="breadcrumb_title_ja" form={formik} /></span>
                  </div>
                  <div className="col-md-12 text-center form-group">
                    <label htmlFor="slug" className="text-left d-flex">{"Slug"}:<span className="requirestar">*</span>{" "}</label>
                    <input name="slug" id="slug" type="text" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.slug} className="form-control" placeholder={"Please enter slug"} />
                    <span className="text-danger d-flex text-left"><CustomError name="slug" form={formik} /></span>
                  </div>

                  <div className="col-md-6 text-center form-group">
                    <label
                      htmlFor="description"
                      className="text-left d-flex"
                    >
                      Description:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <textarea
                      name="description"
                      id="description"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.description}
                      className="form-control"
                      placeholder={"Please enter description"}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="description" form={formik} />
                    </span>
                  </div>
                  <div className="col-md-6 text-center form-group">
                    <label
                      htmlFor="description_ja"
                      className="text-left d-flex"
                    >
                      Description Japanese:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <textarea
                      name="description_ja"
                      id="description_ja"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.description_ja}
                      className="form-control"
                      placeholder={"Please enter description_ja"}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="description_ja" form={formik} />
                    </span>
                  </div>

                  <div className="mt-5">
                    <button
                      onClick={() => {
                        setSaveType("Save");
                      }}
                      className="btn btn-info mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save")}
                    </button>
                    <button
                      onClick={() => {
                        setSaveType("");
                      }}
                      className="btn btn-success mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save_exit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default ManualGuideEdit;
